<section>
  <div mat-dialog-title>
    <h1 fxFlexAlign="start">{{data.title}}</h1>
    <div class="box"
         fxLayout="row"
         fxLayoutAlign="space-between center"
         *ngIf="showSubtitle">
      <span class="box-text">{{data.subtitle}}</span>
    </div>
  </div>

  <mat-dialog-content fxLayout="column"
                      fxLayoutAlign="start start"
                      *ngIf="data.descriptionFirst || data.descriptionSecond">
    <span class="item"
          *ngIf="data.descriptionFirst"
          [innerHTML]="data.descriptionFirst"></span>
    <span class="item"
          *ngIf="data.descriptionSecond"
          [innerHTML]="data.descriptionSecond"></span>
  </mat-dialog-content>

  <mat-dialog-actions align="end"
                      fxLayout="row"
                      fxLayoutAlign="space-between center">
    <button mat-dialog-close
            mat-stroked-button
            *ngIf="!data.onlyOkButton">
      <mat-icon>close</mat-icon>
      <span>NÃO</span>
    </button>
    <button color="primary"
            mat-raised-button
            type="submit"
            [mat-dialog-close]="true">
      <mat-icon>check</mat-icon>
      <span>{{ data.onlyOkButton ? 'OK' : 'SIM' }}</span>
    </button>
  </mat-dialog-actions>
</section>
